import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const TestimonialSection = () => {
  const testimonials = [
  {
    name: 'Marcus T.',
    role: 'Executive, 34',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1c1947421-1763296256842.png",
    imageAlt: 'Professional man in his fifties with confident expression in business setting',
    rating: 5,
    text: 'I\'ve done the programs. Read the books. This was different. The Performer pattern explained why I felt empty after every achievement. Finally, someone who gets it.'
  },
  {
    name: 'David R.',
    role: 'Consultant, 48',
    image: "/assets/images/david_r_relatable_man.png",
    imageAlt: 'Everyday relatable man in his late forties with warm genuine smile and approachable demeanor',
    rating: 5,
    text: 'No bullshit. No motivational clichés. Just the mechanism. The Controller archetype results were uncomfortably accurate. The recommendations actually work.'
  },
  {
    name: 'James K.',
    role: 'Business Owner, 51',
    image: "/assets/images/james_k_relatable_man.png",
    imageAlt: 'Everyday relatable man in his early fifties with friendly expression and down-to-earth appearance',
    rating: 5,
    text: 'I was skeptical. Another assessment? But this identified the exact pattern I\'ve been running since childhood. The Ghost archetype explained everything.'
  }];


  return (
    <div className="w-full max-w-6xl mx-auto px-4 md:px-6 lg:px-8">
      <div className="text-center mb-12 md:mb-16">
        <h2 className="text-3xl md:text-4xl font-bold text-brand-white mb-4 uppercase tracking-tight">
          What Men Are Saying
        </h2>
        <p className="text-lg md:text-xl text-brand-steel max-w-2xl mx-auto">
          Successful men who were stuck. Now they're not.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {testimonials?.map((testimonial, index) =>
        <div
          key={index}
          className="bg-brand-black rounded-lg p-7 border border-brand-slate hover:border-brand-gold transition-all duration-250">

            {/* Rating Stars */}
            <div className="flex gap-1 mb-4">
              {[...Array(testimonial?.rating)]?.map((_, i) =>
            <Icon
              key={i}
              name="Star"
              size={16}
              color="#C9A227"
              className="fill-current" />

            )}
            </div>

            {/* Testimonial Text */}
            <p className="text-base text-brand-white leading-relaxed mb-6">
              "{testimonial?.text}"
            </p>

            {/* Author Info */}
            <div className="flex items-center gap-3 pt-4 border-t border-brand-slate">
              <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0 bg-brand-slate">
                <Image
                src={testimonial?.image}
                alt={testimonial?.imageAlt}
                className="w-full h-full object-cover" />

              </div>
              <div className="flex-1">
                <p className="font-bold text-brand-white text-base">
                  {testimonial?.name}
                </p>
                <p className="text-sm text-brand-steel">
                  {testimonial?.role}
                </p>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Stats Section */}
      <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-6">
        {[
        { number: '10K+', label: 'Men Assessed' },
        { number: '28-76', label: 'Age Range' },
        { number: '94%', label: 'Report Accuracy' },
        { number: '3 Min', label: 'Completion Time' }]?.
        map((stat, index) =>
        <div
          key={index}
          className="text-center p-6 bg-brand-black rounded-lg border border-brand-slate">

            <div className="text-3xl md:text-4xl font-bold text-brand-gold mb-2">
              {stat?.number}
            </div>
            <div className="text-sm text-brand-steel uppercase tracking-wide">
              {stat?.label}
            </div>
          </div>
        )}
      </div>
    </div>);

};

export default TestimonialSection;